import './App.css';

function Accountdel() {

  return (
    <div className="App">
      <p>
        To request account deletion for Alastar Mobile or Alastar Collaboration, please email support@alastar.com from the email associated with the account, as well as your full name.
      </p>
      <p>
        All data associated with this email will be removed, including: location data, personal information (email, phone number, device ID), and any other data associated with your account.
      </p>
    </div>
  );
}
export default Accountdel;
